import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledCard = styled(Flexbox)(
    ({theme: {palette, shadows, spacing}}) => css`
        padding: ${spacing * 4}px;
        background-color: ${palette.neutral.white};
        border-radius: 12px;
        border: 1px solid ${palette.neutral['200']};
        transition: box-shadow 0.3s ease;
        height: 100%;
        &:hover {
            box-shadow: ${shadows.md};
        }
    `
)
